// extracted by mini-css-extract-plugin
export default {"asterisk":"asterisk_asterisk__1buru"};